import CirgsNewReport from './CirgsNewReport';

export default CirgsNewReport;
